"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Spinner = function Spinner(_ref) {
  var showSpinner = _ref.showSpinner;
  return showSpinner ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-logo"
  })) : null;
};
exports.Spinner = Spinner;
Spinner.defaultProps = {
  showSpinner: false
};
Spinner.propTypes = {
  showSpinner: _propTypes.default.bool
};
